<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="rocket"/>
          {{$t('messageCampaign')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('draft')"></b-tab>
          <b-tab :title="$t('sending')"></b-tab>
          <b-tab :title="$t('finished')"></b-tab>
          <b-tab :title="$t('submitError')"></b-tab>
          <b-tab :title="$t('waitToDelete')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load" :placeholder="$t('keyword')"></b-form-input>
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1" @input="load"></client-select>
            <form-select :model="filterFormModel" attribute="type" :options="typeOptions" class="mr-1 mb-1"></form-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-4">{{ $t('status') }}</div>
            <div class="col-lg-2">{{ $t('result') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <div>
                <!--<span>{{$t('messageType')}}</span>:-->
                <span v-if="item.type === 'zns'" class="badge badge-info">{{ $t(item.type) }}</span>
                <span v-else-if="item.type === 'viber'" class="badge badge-primary">{{ $t(item.type) }}</span>
                <span v-else class="badge badge-success">{{ $t(item.type) }}</span>

                <span class="badge badge-primary ml-1"
                      v-if="item.type === 'sms' && item.smsType === 'care'">{{ $t('care') }}</span>
                <span class="badge badge-info ml-1"
                      v-else-if="item.type === 'sms' && item.smsType === 'ads'">{{ $t('ads') }}</span>
              </div>
              <div v-if="item.client.companyName"><span>{{$t('companyName')}}</span>: <b> {{item.client.companyName}} </b></div>
              <div><span>{{$t('domain')}}: </span><b>{{ item.client.domain }}</b></div>
              <div><span>{{ $t('campaignName') }}</span>: <b>{{ item.name }}</b></div>
              <div v-if="item.type === 'sms'">
                <div>
                  <span>{{ $t('brandName') }}</span>:
                  <b v-if="item.smsBrandName">{{ item.smsBrandName.name }}</b>&nbsp;
                </div>
                <div v-if="item.smsType === 'care'">
                  <span>{{ $t('template') }}</span>:
                  <b v-if="item.smsTemplate">{{ item.smsTemplate.name }}</b>&nbsp;
                </div>
              </div>
              <div v-else-if="item.type === 'zns'">
                <div>
                  <span>{{ $t('template') }}</span>:
                  <b v-if="item.znsTemplate">{{ item.znsTemplate.name }}</b>&nbsp;
                </div>
                <div>
                  <span>{{ $t('zaloOA') }}</span>:
                  <b v-if="item.oa">{{ item.oa.name }}</b>&nbsp;
                </div>
              </div>
              <div v-else-if="item.type === 'viber'">
                <div>
                  <span>{{ $t('brandName') }}</span>:
                  <b v-if="item.viberBrandName">{{ item.viberBrandName.name }}</b>&nbsp;
                </div>
              </div>
              <div v-if="item.refId"><span>Ref Id: </span><b>{{ item.refId }}</b></div>
            </div>
            <div class="col-lg-4">
              <div>
                <span v-if="item.setTimer" class="badge badge-primary mb-1">
                  {{ $t('setTimer') }}:
                  <span v-if="item.scheduledSendTime">{{ item.scheduledSendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                  <i v-else>{{ $t('notUpdated') }}</i>
                </span>
              </div>

              <div v-if="item.createTime">
                <span>{{ $t('createTime') }}: </span> <b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.startTime">
                <span>{{ $t('startTime') }}: </span> <b>{{ item.startTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.finishTime">
                <span>{{ $t('finishTime') }}: </span> <b>{{ item.finishTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.scheduledDelTime">
                <span>{{ $t('scheduledDelTime') }}: </span> <b>{{ item.scheduledDelTime| moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.createdBy"><span>{{ $t('createdBy') }}</span>: <b>{{ item.createdBy.name }}
                ({{ item.createdBy.ext }})</b></div>
              <div v-if="item.startedBy"><span>{{ $t('sentBy') }}</span>: <b>{{ item.startedBy.name }}
                ({{ item.startedBy.ext }})</b></div>
              <div v-if="item.confirmTime"><b>{{$t('confirmTime')}}: </b><span>{{item.confirmTime | moment('DD/MM/YYYY HH:mm')}}</span></div>
              <div v-if="item.confirmedBy"><b>{{$t('confirmedBy')}}: </b><span>{{item.confirmedBy.name}}</span></div>

            </div>
            <div class="col-lg-2">
              <div>
                <span v-if="item.error" class="badge badge-danger">{{ item.errorMsg || $t('submitError') }}</span>
                <span v-else-if="item.finishTime" class="badge badge-success">{{ $t('finished') }}</span>
                <span v-else-if="item.startTime && !item.confirmTime" class="badge badge-warning">{{$t('submit')}}</span>
                <span v-else-if="item.startTime" class="badge badge-warning"><b-spinner type="grow" small></b-spinner>{{$t('processing')}}</span>
                <span v-else class="badge badge-secondary">{{ $t('draft') }}</span>
                <span v-if="item.scheduledDelTime" class="badge badge-danger ml-1">{{ item.errorMsg || $t('waitToDelete') }}</span>
              </div>
              <div class="mt-2">
                <span>{{ $t('numberOfContact') }}: </span>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <b v-else-if="contactReport[item._id]">{{ contactReport[item._id].total | numFormat }}</b>
                <b v-else>0</b>
              </div>
              <div v-if="item.startTime">
                <span>{{ $t('numberOfContactSent') }}: </span>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <b v-else-if="contactReport[item._id]">{{ contactReport[item._id].success | numFormat }}</b>
                <b v-else>0</b>
              </div>
              <div v-if="item.startTime">
                <span>{{ $t('numberOfErrorContact') }}: </span>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <b v-else-if="contactReport[item._id]">{{ contactReport[item._id].failure | numFormat }}</b>
                <b v-else>0</b>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner', 'tech', 'admin', 'account'].includes($store.state.user.role)">
                    <button @click="rollBack(item._id)" type="button" class="btn btn-sm btn-success mr-1" v-if="item.type === 'sms' && item.smsType === 'ads' && item.startTime && !item.confirmTime && !item.finishTime">
                      <font-awesome-icon icon="retweet"/>&nbsp;{{ $t('rollBack') }}
                    </button>
                    <button @click="confirm(item._id)" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'sms' && item.smsType === 'ads' && item.startTime && !item.confirmTime && !item.finishTime">
                      <font-awesome-icon icon="check"/>&nbsp;{{ $t('confirm') }}
                    </button>
                    <button @click="finish(item._id)" type="button" class="btn btn-sm btn-warning mr-1" v-if="item.startTime && !item.finishTime">
                      <font-awesome-icon icon="stop"/>&nbsp;{{ $t('finish') }}
                    </button>
                  </div>
                  <div class="c-buttons__col">
                    <s-m-s-ads-add-failed-contact v-if="item.type === 'sms' && item.smsType === 'ads' && item.confirmTime" :campaign="item._id"></s-m-s-ads-add-failed-contact>
                    <s-m-s-ads-upload-failed-contacts class="ml-1" v-if="item.type === 'sms' && item.smsType === 'ads' && item.confirmTime" :campaign="item._id"></s-m-s-ads-upload-failed-contacts>
                  </div>
                  <campaign-info :campaign="item"></campaign-info>
                  <div class="c-buttons__col" v-if="['owner', 'tech', 'admin', 'account'].includes($store.state.user.role)">
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1" v-if="!item.startTime">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "@/components/ClientSelect";
import SMSAdsAddFailedContact from "@/views/message/SMSAdsAddFailedContact";
import SMSAdsUploadFailedContacts from "@/views/message/SMSAdsUploadFailedContacts";
import CampaignInfo from "./CampaignInfo.vue";


export default {
  components: {CampaignInfo, ClientSelect, SMSAdsAddFailedContact, SMSAdsUploadFailedContacts},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/message-campaign',
      defaultFilterFormModel: {
        keyword: null,
        type: null
      },
      typeOptions: [
        {value: null, text: this.$t('messageType')},
        {value: 'sms', text: this.$t('sms')},
        {value: 'viber', text: this.$t('viber')},
        {value: 'zns', text: this.$t('zns')},
        {value: 'zaloOA', text: this.$t('zaloOA')},
        {value: 'facebook', text: this.$t('facebook')},
        {value: 'whatsapp', text: this.$t('whatsapp')},
      ],
      resultLoading: false,
      contactReport: {},
      afterLoad(){
        this.getResults();
      },
    }
  },
  methods: {
    rollBack: function (id) {
      this.$swal({
        title: this.$t('adsCampaignRollBackConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/roll-back/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('rollBackSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('rollBackFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    confirm: function (id) {
      this.$swal({
        title: this.$t('adsCampaignConfirmConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/confirm/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('confirmSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('confirmFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    getResults() {
      this.resultLoading = true;
      let ids = this.items.map(item => {
        return item._id;
      })
      if (ids && ids.length) {
        this.$service.post(this.service + "/contact-count", {ids: ids}).then(response => {
          this.contactReport = {};
          response.data.forEach(item => {
            this.contactReport[item._id] = item;
          });
        }).finally(() => {
          this.resultLoading = false;
        });
      }
    },
    finish: function (id) {
      this.$swal({
        title: this.$t('campaignFinishConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/finish/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('finishSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('finishFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
  },
  i18n: {
    messages: {
      en: {
        viberCampaign: 'Viber campaign',
        ads: 'Ads',
        care: 'Care',
        draft: 'Draft',
        started: 'Started',
        sending: 'Sending',
        finished: 'Finished',
        companyName: 'Company name',
        info: 'Campaign info',
        status: 'Status',
        result: 'Result',
        createTime: 'Create time',
        startTime: 'Start time',
        confirmTime: 'Confirm time',
        finishTime: 'Finish time',
        confirmedBy: 'Confirmed by',
        type: 'Campaign type',
        adsCampaignConfirmConfirm: 'Are you sure to confirm this ads campaign?',
        confirmSuccess: "Campaign confirmed!",
        confirm: 'Confirm',
        finish: 'Finish',
        finishSuccess: 'Campaign finished!',
        finishFailed: 'Campaign finished failed!',
        campaignFinishConfirm: 'Are you sure to finish this campaign?',
        rollBack: 'Roll back',
        adsCampaignRollBackConfirm: 'Are you sure to roll back this campaign',
        rollBackSuccess: 'Campaign rolled back!',
        rollBackFailed: 'Fail to roll back',
        submitError: "Error",
        messageType: "Message type",
        sms: "SMS",
        viber: "Viber",
        zns: "Zalo ZNS",
        campaignName: "Campaign name",
        brandName: "BrandName",
        template: "Template",
        createdBy: "Created by",
        sentBy: "Send by",
        numberOfContact: "Number of contact",
        numberOfContactSent: "Number of contact sent",
        numberOfContactSending: "Number of contact sending",
        numberOfErrorContact: "Number of error contact",
        setTimer: "Set timer",
        submit: "Submit",
        processing: "Processing",
        waitToDelete: "Wait to delete",
        scheduledDelTime: "Scheduled delete",
        messageCampaign: "Message campaign",
        zaloOA: "Zalo OA",
        facebook: "Facebook",
        whatsapp: "WhatsApp",
      },
      vi: {
        smsCampaign: 'Chiến dịch SMS',
        ads: 'Quảng cáo',
        care: 'CSKH',
        draft: 'Nháp',
        started: 'Đã bắt đầu',
        sending: 'Đang gửi',
        finished: 'Đã gửi',
        companyName: 'Tên khách hàng',
        info: 'Thông tin chiến dịch',
        status: 'Trạng thái',
        result: 'Kết quả',
        createTime: 'Tạo lúc',
        startTime: 'Bắt đầu lúc',
        confirmTime: 'Xác nhận lúc',
        finishTime: 'Hoàn thành lúc',
        confirmedBy: 'Xác nhận bởi',
        type: 'Loại chiến dịch',
        adsCampaignConfirmConfirm: 'Hãy đảm bảo chắc chắn rằng bên cung cấp dịch vụ nhắn tin quảng cáo đã xác nhận nội dung tin nhắn là hợp lệ. Hành động xác nhận này sẽ trừ tiền trong tài khoản của khách hàng!',
        confirmSuccess: "Chiến dịch đã được xác nhận!",
        confirm: 'Xác nhận',
        finish: 'Hoàn thành',
        finishSuccess: 'Chiến dịch đã hoàn thành!',
        finishFailed: 'Có lỗi xảy ra! Chiến dịch chưa hoàn thành!',
        campaignFinishConfirm: 'Bạn có chắc muốn hoàn thành chiến dịch này?',
        rollBack: 'Quay lại',
        adsCampaignRollBackConfirm: 'Bạn có chắc muốn roll back chiến dịch này?',
        rollBackSuccess: 'Chiến dịch đã được roll back',
        rollBackFailed: 'Roll back thất bại',
        viberCampaign: "Chiến dịch viber",
        submitError: "Không thành công",
        messageType: "Loại tin nhắn",
        sms: "SMS",
        viber: "Viber",
        zns: "Zalo ZNS",
        campaignName: "Tên chiến dịch",
        brandName: "BrandName",
        template: "Mẫu tin nhắn",
        createdBy: "Tạo bởi",
        sentBy: "Gửi bởi",
        numberOfContact: "Số liên hệ",
        numberOfContactSent: "Số liên hệ đã gửi",
        numberOfContactSending: "Số liên hệ đang gửi",
        numberOfErrorContact: "Số liên hệ gửi lỗi",
        setTimer: "Hẹn giờ",
        submit: "Chờ duyệt",
        processing: "Đang xử lý",
        waitToDelete: "Chờ xoá",
        scheduledDelTime: "Hẹn giờ xoá",
        messageCampaign: "Chiến dịch gửi tin nhắn",
        zaloOA: "Zalo OA",
        facebook: "Facebook",
        whatsapp: "WhatsApp",
      }
    }
  },
};
</script>